<template>
  <CLoadingButton
    :loading="loading"
    disabled-on-loading
    :disabled="disabled"
    :color="color"
    :shape="shape"
    :size="size"
    :type="type"
    :variant="variant"
    :spinner-type="spinnerType"
    :class="{ 'w-100': block }"
    @click="$emit('click')"
  >
    <slot />
  </CLoadingButton>
</template>

<script>
// Thin wrapper over CLoadingButton. `timeout` is intentionally not passed so
// the button never auto-clears its own loading state on click.
export default {
  name: 'ButtonLoading',

  props: {
    loading: Boolean,
    disabled: Boolean,
    block: Boolean,
    color: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: 'button'
    },
    spinnerType: {
      type: String,
      default: 'border'
    },
    shape: {
      type: String,
      default: undefined
    },
    variant: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    }
  },

  emits: ['click']
}
</script>
